/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const u = ({ finisher: e, descriptor: t }) => (n, l) => {
  var o;
  if (l === void 0) {
    const r = (o = n.originalKey) !== null && o !== void 0 ? o : n.key, i = t != null ? { kind: "method", placement: "prototype", key: r, descriptor: t(n.key) } : { ...n, key: r };
    return e != null && (i.finisher = function(s) {
      e(s, r);
    }), i;
  }
  {
    const r = n.constructor;
    t !== void 0 && Object.defineProperty(n, l, t(l)), e == null || e(r, l);
  }
};
var d;
const a = ((d = window.HTMLSlotElement) === null || d === void 0 ? void 0 : d.prototype.assignedElements) != null ? (e, t) => e.assignedElements(t) : (e, t) => e.assignedNodes(t).filter((n) => n.nodeType === Node.ELEMENT_NODE);
function p(e) {
  const { slot: t, selector: n } = e ?? {};
  return u({ descriptor: (l) => ({ get() {
    var o;
    const r = "slot" + (t ? `[name=${t}]` : ":not([name])"), i = (o = this.renderRoot) === null || o === void 0 ? void 0 : o.querySelector(r), s = i != null ? a(i, e) : [];
    return n ? s.filter((c) => c.matches(n)) : s;
  }, enumerable: !0, configurable: !0 }) });
}
export {
  p as l,
  u as o
};
//# sourceMappingURL=query-assigned-elements-B8U94KLQ.js.map
